import { render, staticRenderFns } from "./sorteo-campana.vue?vue&type=template&id=63158f1c&scoped=true"
import script from "./sorteo-campana.vue?vue&type=script&lang=ts"
export * from "./sorteo-campana.vue?vue&type=script&lang=ts"
import style0 from "./sorteo-campana.vue?vue&type=style&index=0&id=63158f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63158f1c",
  null
  
)

export default component.exports